module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_5010.d91c56f2.png";